import ApiService from './api.service'

const ReportingService = {

  /***
   * Get calculated KPIs for towers
   * @returns {array}
   */
  getCalculatedTowers (params) {
    return ApiService.query('reporting/calculated-towers', params)
  },

}
export default ReportingService
